<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="Basic-Paragraph para-style-override-2"><span class="char-style-override-6">To my sons, Sam and Michael, my stalwart companions during my travels throughout Oregon</span></p>
<p class="Basic-Paragraph para-style-override-6"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0006.vue?6cadc3bf